@if (loading) {
  <app-loading-indicator class="button__loading-indicator" />
} @else {
  <ng-content select="[buttonIcon]:not([iconPositionEnd])" />

  <span class="button__label"><ng-content></ng-content></span>

  <ng-content select="[buttonIcon][iconPositionEnd]" />
}
